import { createAction, props } from '@ngrx/store';

export const managedStoreAction = {
  managedStoreRequest: createAction(
    '[Managed Store] managed store request',
    props<{ page: number; size: number; search?: string }>()
  ),
  managedStoreResponse: createAction('[Managed Store] managed store response', props<{ response: any }>()),
  clearManagedStore: createAction('[Managed Store] clear managed store cache')
};
